import React from "react";
import { useLanguage } from "@/context/LanguageContext";

const LanguageToggle = ({ compact = false }) => {
  const { lang, setLang } = useLanguage();
  return (
    <div
      data-testid="language-toggle"
      className={`inline-flex items-center gap-0.5 rounded-full bg-white border border-blue-900/10 p-1 shadow-sm ${
        compact ? "text-xs" : "text-sm"
      }`}
    >
      <button
        data-testid="lang-ta-btn"
        onClick={() => setLang("ta")}
        className={`px-3 py-1.5 rounded-full font-semibold transition-all ${
          lang === "ta"
            ? "bg-blue-900 text-white shadow"
            : "text-slate-600 hover:text-blue-900"
        }`}
        style={{ fontFamily: "Noto Sans Tamil, sans-serif" }}
      >
        தமிழ்
      </button>
      <button
        data-testid="lang-en-btn"
        onClick={() => setLang("en")}
        className={`px-3 py-1.5 rounded-full font-semibold transition-all ${
          lang === "en"
            ? "bg-blue-900 text-white shadow"
            : "text-slate-600 hover:text-blue-900"
        }`}
        style={{ fontFamily: "Outfit, sans-serif" }}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageToggle;
